import type { ResellerInfo } from '../../types/resaleAuthorization'

export enum ResellerActions {
  SET_RESELLERS_DATA = 'SET_RESELLERS_DATA',
}

export interface ResellerState {
  resellers: ResellerInfo[]
}

export const initialResellerState: ResellerState = {
  resellers: [],
}

export type ResellerAction = {
  type: ResellerActions.SET_RESELLERS_DATA
  payload: ResellerInfo[]
}
